export default __webpack_public_path__ + "static/media/photo1.878ed581.jpg";